/** Russian for `uz-09-tour-info`. The type makes a missing key a compile error. */
import type { TranslationKey } from "./uz";

export const ruTourInfo09: Record<Extract<TranslationKey, `tourinfo.${string}`>, string> = {
  "tourinfo.status.title": "Состояние поставщиков",
  "tourinfo.group.working": "Идёт поиск",
  "tourinfo.group.answered": "Ответили",
  "tourinfo.group.failed": "Ошибка — поставщик не ответил",
  "tourinfo.group.notSelling": "Не продаёт это направление или не подключён",
  "tourinfo.chip.pending": "В очереди",
  "tourinfo.chip.running": "Идёт поиск",
  "tourinfo.chip.results": "Результатов: {count}",
  "tourinfo.chip.none": "Нет результатов",
  "tourinfo.chip.noDestination": "Нет такого направления",
  "tourinfo.chip.notCovered": "Не охвачено",
  "tourinfo.chip.error": "Ошибка",
  "tourinfo.chip.skipped": "Пропущен",
  "tourinfo.partial.title": "Результаты неполные: не ответили поставщики ({count}).",
  "tourinfo.partial.fallback": "Поставщик временно не работает.",
  "tourinfo.empty.partial":
    "У ответивших поставщиков предложений нет, остальные не ответили. Это не значит «нет результатов»: повторите поиск чуть позже.",
  "tourinfo.empty.noSupplier": "Подключённые поставщики не продают это направление. Выберите другое.",
  "tourinfo.truncated": "Показано {shown} из {total} предложений, фильтры работают только среди них.",

  "tourinfo.age.now": "Цена получена только что",
  "tourinfo.age.minutes": "Цена получена {count} мин. назад",
  "tourinfo.age.hours": "Цена получена {count} ч. назад",
  "tourinfo.age.days": "Цена получена {count} дн. назад",
  "tourinfo.age.stale": "Цена устарела, проверьте заново",

  "tourinfo.source": "Источник: {source}",
  "tourinfo.source.agency": "замер агентства",
  "tourinfo.source.routed": "дорожный сервис",
  "tourinfo.source.straight": "по координатам, по прямой",
  "tourinfo.source.provider": "данные поставщика",
  "tourinfo.airport.value": "До аэропорта {km} км, {minutes} мин.",
  "tourinfo.airport.approx": "До аэропорта {km} км, примерно {minutes} мин.",
  "tourinfo.airport.unknown": "До аэропорта: расположение не определено",
  "tourinfo.beach.value": "До пляжа {metres} м",
  "tourinfo.beach.none": "До пляжа: замер не внесён",
  "tourinfo.location.unmatched": "Отель не привязан к каталогу: расположение не определено",
  "tourinfo.distance.failed": "Не удалось получить расстояние.",

  "tourinfo.variants.title": "Четыре варианта",
  "tourinfo.slot.cheapest": "Дешёвый",
  "tourinfo.slot.middle": "Средний",
  "tourinfo.slot.premium": "Премиум",
  "tourinfo.slot.halal": "Халяль",
  "tourinfo.variants.budget": "Бюджет, {currency}",
  "tourinfo.variants.none": "В этом поиске подходящего варианта нет",
  "tourinfo.variants.premiumNone": "В пределах бюджета премиум-варианта нет",
  "tourinfo.variants.currency": "Четыре варианта выбираются только из предложений в USD и сумах.",
  "tourinfo.variants.failed": "Не удалось загрузить варианты.",

  "tourinfo.panel.open": "Анализ",
  "tourinfo.panel.distances": "Расстояния",
  "tourinfo.panel.warnings": "Предупреждения",
  "tourinfo.panel.facts": "Сведения",
  "tourinfo.panel.pros": "Преимущества",
  "tourinfo.panel.cons": "Недостатки",
  "tourinfo.panel.missing": "Нет в системе",
  "tourinfo.panel.failed": "Не удалось загрузить анализ.",
  "tourinfo.notes.title": "Заметки агентства",
  "tourinfo.notes.empty": "Заметок пока нет.",
  "tourinfo.notes.failed": "Не удалось загрузить заметки.",
  "tourinfo.notes.kind": "Тип",
  "tourinfo.notes.kind.complaint": "Жалоба",
  "tourinfo.notes.kind.renovation": "Ремонт",
  "tourinfo.notes.kind.other": "Другое",
  "tourinfo.notes.text": "Заметка",
  "tourinfo.notes.save": "Сохранить",
  "tourinfo.notes.saveFailed": "Не удалось сохранить заметку.",
};
